import React from "react";
import { useDrop } from "react-dnd";

import ItemTypes from "../ItemTypes";

function DropZone({ height, width, Graph, entityId, children }) {
  const [{ isOver }, drop] = useDrop({
    accept: ItemTypes.EMPLOYEE,
    drop: ({ selected, idDragged }) => {
      const selected_arr = Object.keys(selected).filter(
        k => selected[k] && k !== idDragged
      );
      Graph.addEmployees(entityId, [idDragged, ...selected_arr]);
    },
    collect: mon => ({
      isOver: !!mon.isOver()
    })
  });

  return (
    <div
      ref={drop}
      style={{
        backgroundColor: isOver && "lightcyan",
        height,
        width,
        zIndex: 5,
        padding: "0.5em 2.5em"
      }}
    >
      {children}
    </div>
  );
}

export default DropZone;
